import { toast } from "react-toastify";
import {
  handleAuthentication,
  hasError,
  startLoading,
  stopLoading,
} from "../redux/slices/loginApiSlice.ts";
import { method, paths } from "./ServiceConstants.tsx";
import ServicesManagerAPICall from "./ServicesManagerAPICall.tsx";
import { LOGIN_STATUS, NO_TOKEN } from "../utils/Constants.tsx";
import { IPublicClientApplication } from "@azure/msal-browser";
import { removeAllItemsFromLocalStorage, setRedirect } from "../utils/Util.tsx";

export const postSSOLogin = (data, setIsLoading) => {
  return async (dispatch: any) => {
    setIsLoading(true);
    try {
      await ServicesManagerAPICall.request(
        method.POST,
        paths.LOGIN,
        data,
        true,
        true
      ).then(
        async (res: any) => {
          setIsLoading(false);
          if (res) {
            if (res?.api_token?.length > 0) {
              let data = {
                authStatus: LOGIN_STATUS.AUTHENTICATED,
                token: res.api_token,
                message: res?.message,
              };
              dispatch(handleAuthentication(data));
            } else {
              dispatch(handleAuthentication({}));
              toast.error(res?.message);
            }
          } else {
            dispatch(handleAuthentication({}));
            toast.error("Unauthorized login");
          }
         setRedirect(false)
        },
        (err: any) => {
          dispatch(stopLoading());
          dispatch(handleAuthentication({}));
          toast("Unable to login, please try again later");
          setRedirect(false)
        }
      );
    } catch (error) {
      dispatch(stopLoading());
      dispatch(handleAuthentication({}));
      toast("Unable to login, please try again later");
      dispatch(hasError(error));
      setRedirect(false)
    }
  };
};
export const logout = (instance: IPublicClientApplication) => {
  return async (dispatch: any) => {
    dispatch(startLoading());
    try {
      await ServicesManagerAPICall.request(
        method.POST,
        paths.LOGOUT,
        {},
        true,
        true
      ).then(
        async (res: any) => {
          if (res != null) {
            dispatch(
              handleAuthentication({
                authStatus: LOGIN_STATUS.NO_AUTHENTICATED,
                token: NO_TOKEN,
              })
            );
            removeAllItemsFromLocalStorage()
            toast.success("Successfully logged out");
            instance.logoutRedirect();
          } else {
            toast.error(res?.message || "Logout failed");
          }
          dispatch(stopLoading());
        },
        (err: any) => {
          dispatch(stopLoading());
          toast.error("Unable to logout, please try again later");
        }
      );
    } catch (error) {
      dispatch(stopLoading());
      toast.error("Unable to logout, please try again later");
      dispatch(hasError(error));
    }
  };
};
